import { inject, Injectable } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { map, Observable, catchError, of, switchMap, take } from 'rxjs';

import { selectSessionUser } from 'src/app/auth/store/session/session.selectors';
import { SessionActions } from 'src/app/auth/store/session/session.actions';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticatedGuardService {
  constructor(private store: Store, private router: Router, private authService: AuthService) {}

  canActivate(): Observable<boolean> {
    return this.store.select(selectSessionUser).pipe(
      switchMap(user => {
        if (user === null) {
          return this.authService.getUser().pipe(
            take(1),
            map(user => {
              this.store.dispatch(SessionActions.get_user_success({ user }));
              return true;
            }),
            catchError(error => {
              if (error.status === 401) {
                this.router.navigate(['/login']);
              } else {
                // TODO (global error handling): navigate to general error page
                this.router.navigate(['/login']);
              }
              return of(false);
            })
          );
        } else {
          return of(true);
        }
      })
    );
  }
}

export const AuthenticatedGuard: CanActivateFn = () => {
  return inject(AuthenticatedGuardService).canActivate();
};
